<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div *ngIf="viewType=='Compact'" class="compact-breadcumb-view flex flex-row justify-start items-center">
    <particle-select-basket (basketChange)="onBasketChange($event)" class="m-l-30 m-r-20"></particle-select-basket>
    <particle-breadcumb-tab-action [breadcrumbs]="breadcrumbs"
                                   [tabs]="tabs[currentBasketId]"
                                   [selectedTab]="selectedTab"
                                   [actions]="actions"
                                   (viewTypeChanged)="viewTypeChanged($event)"
                                   (selectedTabChanged)="onSelectedTabChanged($event)"
    >
    </particle-breadcumb-tab-action>
  </div>
  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
      <particle-select-basket (basketChange)="onBasketChange($event)" class="m-r-20"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
      <button class="view-change" (click)="compactViewType()">
        <i class="fas fa-expand-alt"></i>
      </button>
    </div>
  </div>

  <div *ngIf="viewType!=='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <div *ngIf="selectedTab" class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createFiling()"
                  particleAnalytics
                  analyticsCategory="OpenStatusSettings"
                  analyticsAction="OpenStatusSettings"
          >{{selectedTab.addFilingTitle}}
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="openStatusSettings()"
                  particleAnalytics
                  analyticsCategory="OpenStatusSettings"
                  analyticsAction="OpenStatusSettings"
          >Status Settings
          </button>
          <div class="toolbar-separator"></div>
        </div>

        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center" *ngIf="selectedTab">-->
        <!--          <particle-grid-apply-filter *ngIf="applyFilterId" [filterId]="applyFilterId"-->
        <!--                                      [endpointName]="endpoint"-->
        <!--                                      [invalidateSubject] = "selectedTab.invalidateSubject">-->
        <!--          </particle-grid-apply-filter>-->
        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageSection(selectedTab.sourceKey)"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="manage-fields"
          >Manage Fields
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="export()"
                  particleAnalytics
                  analyticsCategory="Export"
                  analyticsAction="Export"
          >Export
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="bulkArchive()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="archive"
          >Archive Case(s)
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <mat-slide-toggle class="left-margin" [(ngModel)]="showArchived" (change)="showArchivedChanged()">Show
            Archived
          </mat-slide-toggle>
          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="dac6-filing" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div class="content pos-relative p-0 flex flex-col full-grow-no-shrink-no-basis">
          <mat-tab-group *ngIf="isTabDataLoaded" [ngClass]="viewType=='Compact'? 'tab-header-hide':''"
                         (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
            <mat-tab *ngFor="let tab of tabs[currentBasketId]" [label]="tab.header">
              <div class="keno-grid-container m-30">
                <particle-virtual-grid [sourceKey]="tab.sourceKey" *ngIf="selectedFieldSectionIndex === tab.index"
                                       [invalidateSubject]="tab.invalidateSubject"
                                       sortFieldKey="CaseId"
                                       prefixSortFieldKey="FieldValues."
                                       sortDirection="desc"
                                       (valueChanged)="onGridCellValueChange($event)"
                                       serviceName="{{tab.sourceKey + 'DynamicItemService'}}"
                                       api="DAC6Api"
                >
                </particle-virtual-grid>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
